import * as React from "react";
import * as moment from "moment";
import CSS from "csstype";
import {ordinalSuffixOf} from "utils/number";

interface IProps {
    emi: number;
    tenure: number;
}

const moratoriumMonths = [2, 4, 6];
const green = "#B6D7A8";
const dark = "#575757";
const black = "#000000";
const white = "#FFFFFF";
const header = "Header";
const moratorium = "Moratorium";
const normal = "Normal";
const generateRowUi = (data: string[], rowType: string) => {
    const rowStyle: CSS.Properties = {
        display: "flex",
        flexDirection: "row",
        backgroundColor: rowType === header ? dark : rowType === moratorium ? green : white,
        color: rowType === header ? white : black,
        fontSize: rowType === header ? "12px" : "10px",
        fontWeight: rowType === header ? "bold" : "normal",
        letterSpacing: rowType === header ? "0.24px" : "0.2px",
    };

    return (
        <div key={data[1]} style={rowStyle}>
            {data.map((currentData, i) => {
                return (
                    <div key={i} style={{
                        display: "flex",
                        flexDirection: "row",
                        textAlign: "center",
                        justifyContent: "center",
                        alignItems: "center",
                        borderLeft: "1px solid #ACACAC",
                        borderRight: i === 2 ? "1px solid #ACACAC" : "0px",
                        flex: i === 1 ? 2 : 1.5,
                        height: 40,
                    }}>
                        {data[i]}
                    </div>
                );
            })}
        </div>
    );
};

const generateRows = (emi: number, noOfMonths: number) => {
    let emiMonth = 0;
    return Array.from(Array(noOfMonths), (_, i) => i + 1).map((currentMonth) => {
        if (moratoriumMonths.includes(currentMonth)) {
            return generateRowUi(["Moratorium Period",
                    `Month ${currentMonth}` , "-"],
                moratorium);
        } else {
            emiMonth += 1;
            return generateRowUi([ordinalSuffixOf(emiMonth) + " EMI",
                `Month ${currentMonth}`,
                String(emi) + "/-"], normal);
        }
    });
};

export default function MoratoriumProductTable(props: IProps) {
    return (
        <div style={{borderTop: "1px solid #ACACAC", borderBottom: "1px solid #ACACAC"}}>
            {generateRowUi(["Repayment", "Month", "Amount"], header)}
            {generateRows(props.emi, props.tenure)}
        </div>
    );
}
